import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/69887e8e921dc900143642b0/website_project/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69887e8e921dc900143642b0/website_project/src/components/ui/AppIcon.tsx");
